<!-- MODAL Control efectivo -->
<div mdbModal #controlEfectivo="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" style="overflow-y: auto"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Control de efectivo Recorrido {{ recorrido?.codigo }}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="filtros-body">
          <!-- Datos declarante -->
          <div class="row filtros-header"
            style="border-bottom: 1px solid #dee2e6; justify-content: start; align-items: center">
            <div class="col">
              <h4>Datos Declarante</h4>
            </div>
          </div>

          <div class="row">
            <div class="wow detalle-cliente">
              <div class="card-body justify-content-between">
                <div class="row filtros-body">
                  <div class="dato" style="max-width: 170px">
                    <Strong class="title">Rut</Strong>
                    <span class="value">{{ declarante?.rutUsuarioFormato | rut }}</span>
                  </div>
                  <div class="dato" style="max-width: 300px">
                    <Strong class="title">Nombre</Strong>
                    <span class="value">{{ declarante?.nombre_completo }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col" style="max-width: 250px;">
              <div class="md-form">
                <input value="" type="text" id="declaranteRut" class="form-control" placeholder="99.999.999-9" required
                  #declaranteRut />
                <label for="declaranteRut">RUT</label>
              </div>
            </div>
            <div class="col" style="max-width: 250px;">
              <div class="md-form">
                <input value="" type="text" id="declaranteNombre" class="form-control" placeholder="Nombre" required
                  #declaranteNombre />
                <label for="declaranteNombre">Nombre</label>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col">
              <!-- Declaración de pagos -->
              <div class="row filtros-header pl-0"
                style="border-bottom: 1px solid #dee2e6; justify-content: space-between; align-items: center">
                <div class="col">
                  <h4>Declaración de pagos</h4>
                </div>
              </div>
              <div class="row filtros-header pl-0 montos_resumen">
                <div class="col text-right">
                  <h4>
                    Total del recorrido = <strong>$ {{ montoTotalRecorrido | numerico }}</strong>
                  </h4>
                </div>
              </div>
              <div class="row filtros-header pl-0 montos_resumen" style="border-bottom: 1px solid #dee2e6">
                <div class="col text-right">
                  <h4>
                    Pagados (Cte Cte ó Devoluciones) = <strong>$ {{ montoPagado | numerico }}</strong>
                  </h4>
                </div>
              </div>
              <div class="row filtros-header pl-0 montos_resumen" style="border-bottom: 1px solid #dee2e6">
                <div class="col text-right">
                  <h4>
                    Cobro al Vendedor = <strong>$ {{ montoCobroVendedor | numerico }}</strong>
                  </h4>
                </div>
              </div>
              <div class="row filtros-header pl-0" style="border-bottom: 1px solid #dee2e6">
                <div class="col text-right">
                  <h4>
                    Monto Declarable = <strong>$ {{ resumen?.monto_declarable | numerico }}</strong>
                  </h4>
                </div>
              </div>

              <div class="row">
                <div class="wow detalle-cliente">
                  <div class="card-body justify-content-between">
                    <div class="row filtros-body">
                      <div class="dato" style="max-width: 300px">
                        <Strong class="title">Efectivo</Strong>
                        <span class="value">$ {{ resumen?.efectivo_recaudado | numerico }}</span>
                      </div>
                      <div class="dato" style="max-width: 300px">
                        <Strong class="title">Transferencia</Strong>
                        <span class="value">$ {{ resumen?.cantidad_transferencias | numerico }}</span>
                      </div>
                      <div class="dato" style="max-width: 300px">
                        <Strong class="title">Depósito</Strong>
                        <span class="value">$ {{ resumen?.monto_deposito | numerico }}</span>
                      </div>
                      <!-- </div>
                    <div class="row filtros-body"> -->
                      <div class="dato" style="max-width: 300px">
                        <Strong class="title">Cheque</Strong>
                        <span class="value">$ {{ resumen?.monto_cheque | numerico }}</span>
                      </div>
                      <div class="dato" style="max-width: 300px">
                        <Strong class="title">Diferencial</Strong>
                        <span class="value">$ {{ resumen?.diferencia_monto | numerico }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col">
                  <div class="md-form" style="max-width: 250px;">
                    <input value="" type="text" id="pagoEfectivo" class="form-control" placeholder="$" required
                      #pagoEfectivo />
                    <label for="pagoEfectivo">Efectivo</label>
                  </div>
                  <div class="md-form" style="max-width: 250px;">
                    <input value="" type="text" id="pagoDctoTransferencia" class="form-control" placeholder="$" required
                      #pagoDctoTransferencia />
                    <label for="pagoDctoTransferencia">Dcto./Transferencia</label>
                  </div>
                  <div class="md-form" style="max-width: 250px;">
                    <input value="" type="text" id="pagoDeposito" class="form-control" placeholder="$" required
                      #pagoDeposito />
                    <label for="pagoDeposito">Deposito</label>
                  </div>
                  <div class="md-form" style="max-width: 250px;">
                    <input value="" type="text" id="pagoCheque" class="form-control" placeholder="$" required
                      #pagoCheque />
                    <label for="pagoCheque">Cheque</label>
                  </div>
                  <div class="md-form" style="max-width: 250px;">
                    <input value="" type="text" id="pagoDiferencial" class="form-control" placeholder="$" required
                      #pagoDiferencial />
                    <label for="pagoDiferencial">Diferencial</label>
                  </div>
                </div>
              </div> -->

              <!-- Declaración dinero recibido -->
              <div class="row filtros-header pl-0"
                style="border-bottom: 1px solid #dee2e6; justify-content: space-between; align-items: center">
                <div class="col">
                  <h4>Declaración dinero recibido</h4>
                </div>
                <div class="col text-right">
                  <h4>
                    Total = <strong>$ {{ totalRecibidos | numerico }}</strong>
                  </h4>
                </div>
              </div>
              <form [formGroup]="formRecibidoHeader" novalidate>
                <div class="row">
                  <div class="col">
                    <div class="md-form" style="max-width: 250px">
                      <input value="" type="text" id="recibidoEfectivo" class="form-control" placeholder="$" required
                        #recibidoEfectivo formControlName="efectivo" monto />
                      <label for="recibidoEfectivo">Efectivo</label>
                      <div
                        *ngIf="formRecibidoHeader.get('efectivo').invalid && (formRecibidoHeader.get('efectivo').dirty || formRecibidoHeader.get('efectivo').touched)">
                        <mdb-error *ngIf="formRecibidoHeader.get('efectivo').hasError('required')"> Ingrese monto
                          efectivo </mdb-error>
                      </div>
                    </div>
                    <div class="md-form" style="max-width: 250px">
                      <input value="" type="text" id="recibidoDctoTransferencia" class="form-control" placeholder="$"
                        required #recibidoDctoTransferencia formControlName="dctoTransferencia" monto />
                      <label for="recibidoDctoTransferencia">Dcto./Transferencia</label>
                      <div
                        *ngIf="formRecibidoHeader.get('dctoTransferencia').invalid && (formRecibidoHeader.get('dctoTransferencia').dirty || formRecibidoHeader.get('dctoTransferencia').touched)">
                        <mdb-error *ngIf="formRecibidoHeader.get('dctoTransferencia').hasError('required')"> Ingrese
                          monto dcto./transferencia </mdb-error>
                      </div>
                    </div>
                    <div class="md-form mb-3" style="max-width: 250px">
                      <input value="" type="text" id="recibidoCheque" class="form-control" placeholder="$" required
                        #recibidoCheque formControlName="cheque" monto />
                      <label for="recibidoCheque">Cheque</label>
                      <div
                        *ngIf="formRecibidoHeader.get('cheque').invalid && (formRecibidoHeader.get('cheque').dirty || formRecibidoHeader.get('cheque').touched)">
                        <mdb-error *ngIf="formRecibidoHeader.get('cheque').hasError('required')"> Ingrese monto cheque
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="row filtros-header" style="justify-content: start; align-items: center">
                <div class="col pl-0">
                  <h5>Depósitos</h5>
                </div>
              </div>
              <form [formGroup]="formRecibidoDepositos" novalidate (ngSubmit)="agregarDepositoRecibido()">
                <div class="row">
                  <div class="col" style="max-width: 250px">
                    <div class="md-form">
                      <input value="" type="text" id="recibidoNroDeposito" class="form-control" placeholder="#" required
                        #recibidoNroDeposito formControlName="nroDeposito" monto />
                      <label for="recibidoNroDeposito">Nro. Depósito</label>
                      <div
                        *ngIf="formRecibidoDepositos.get('nroDeposito').invalid && (formRecibidoDepositos.get('nroDeposito').dirty || formRecibidoDepositos.get('nroDeposito').touched)">
                        <mdb-error *ngIf="formRecibidoDepositos.get('nroDeposito').hasError('required')"> Ingrese nro.
                          depósito </mdb-error>
                        <mdb-error *ngIf="formRecibidoDepositos.get('nroDeposito').hasError('min')"> Nro. depósito no
                          válido </mdb-error>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="max-width: 250px">
                    <div class="md-form">
                      <input value="" type="text" id="recibidoDeposito" class="form-control" placeholder="$" required
                        #recibidoDeposito formControlName="monto" monto />
                      <label for="recibidoDeposito">Monto</label>
                      <div
                        *ngIf="formRecibidoDepositos.get('monto').invalid && (formRecibidoDepositos.get('monto').dirty || formRecibidoDepositos.get('monto').touched)">
                        <mdb-error *ngIf="formRecibidoDepositos.get('monto').hasError('required')"> Ingrese monto
                        </mdb-error>
                        <mdb-error *ngIf="formRecibidoDepositos.get('monto').hasError('min')"> Monto no válido
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="max-width: 300px">
                    <div class="md-form">
                      <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" required
                        formControlName="fecha" #fecha> </mdb-date-picker>
                      <div
                        *ngIf="formRecibidoDepositos.get('fecha').invalid && (formRecibidoDepositos.get('fecha').dirty || formRecibidoDepositos.get('fecha').touched)">
                        <mdb-error *ngIf="formRecibidoDepositos.get('fecha').hasError('required')"> Ingrese fecha
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="max-width: 300px">
                    <div class="md-form">
                      <mdb-select label="Banco" placeholder="Banco" [filterEnabled]="true" formControlName="banco"
                        [options]="optionsBancosEmpresa"> </mdb-select>
                      <div
                        *ngIf="formRecibidoDepositos.get('banco').invalid && (formRecibidoDepositos.get('banco').dirty || formRecibidoDepositos.get('banco').touched)">
                        <mdb-error *ngIf="formRecibidoDepositos.get('banco').hasError('required')"> Ingrese banco
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="max-width: 300px">
                    <div class="md-form">
                      <mdb-select label="Nro. cuenta" placeholder="Cuenta" [filterEnabled]="true"
                        formControlName="nroCuenta" [options]="optionsCuentasBancosDeposito"> </mdb-select>
                      <div
                        *ngIf="formRecibidoDepositos.get('nroCuenta').invalid && (formRecibidoDepositos.get('nroCuenta').dirty || formRecibidoDepositos.get('nroCuenta').touched)">
                        <mdb-error *ngIf="formRecibidoDepositos.get('nroCuenta').hasError('required')"> Ingrese nro. de
                          cuenta </mdb-error>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <button mdbBtn type="submit" color="secondary" mdbWavesEffect class="btn">Agregar</button>
                  </div>
                </div>
              </form>
              <div class="row" *ngIf="listaDepositosRecibidos.length > 0">
                <div class="col">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                      <thead class="grey lighten-2">
                        <tr>
                          <th scope="col">Nro. Depósito</th>
                          <th scope="col">Fecha</th>
                          <th scope="col">Banco</th>
                          <th scope="col">Cuenta</th>
                          <th scope="col">Monto</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let deposito of listaDepositosRecibidos">
                          <td>{{ deposito.numero_deposito }}</td>
                          <td>{{ deposito.fecha_deposito | fecha }}</td>
                          <td>{{ deposito.banco_nombre }}</td>
                          <td>{{ deposito.numero_cuenta }}</td>
                          <td>$ {{ deposito.monto | numerico }}</td>
                          <td>
                            <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                              (click)="eliminarDepositoRecibido(deposito)">
                              <mdb-icon fas icon="trash"></mdb-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot class="grey lighten-4">
                        <tr>
                          <th scope="col" colspan="3"></th>
                          <th scope="col" class="text-right">Total</th>
                          <th scope="col">$ {{ totalDepositosRecibidos | numerico }}</th>
                          <th scope="col"></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row filtros-header"
            style="border-bottom: 1px solid #dee2e6; justify-content: start; align-items: center">
            <div class="col">
              <h4>Cargo de ruta</h4>
            </div>
          </div>
          <form [formGroup]="formCargoRuta" novalidate>
            <div class="row">
              <div class="col" style="max-width: 250px">
                <div class="md-form">
                  <input value="" type="text" id="cargoRutaMonto" class="form-control" placeholder="$" required
                    #cargoRutaMonto formControlName="monto" monto />
                  <label for="cargoRutaMonto">Monto</label>
                  <div
                    *ngIf="formCargoRuta.get('monto').invalid && (formCargoRuta.get('monto').dirty || formCargoRuta.get('monto').touched)">
                    <mdb-error *ngIf="formCargoRuta.get('monto').hasError('required')"> Ingrese monto </mdb-error>
                    <mdb-error *ngIf="formCargoRuta.get('monto').hasError('min')"> Monto no válido </mdb-error>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="cargoRutaMotivo" class="form-control" placeholder="EscribeMotivo" maxlength="500"
                    #cargoRutaMotivo formControlName="motivo" />
                  <label for="cargoRutaMotivo">Motivo</label>
                  <!-- <div *ngIf="
                        formCargoRuta.get('motivo').invalid &&
                        (formCargoRuta.get('motivo').dirty ||
                        formCargoRuta.get('motivo').touched)
                      ">
                    <mdb-error *ngIf="formCargoRuta.get('motivo').hasError('required')">
                      Ingrese motivo
                    </mdb-error>
                  </div> -->
                </div>
              </div>
            </div>
          </form>

          <div class="row filtros-header"
            style="border-bottom: 1px solid #dee2e6; justify-content: start; align-items: center">
            <div class="col">
              <h4>Diferencial</h4>
            </div>
          </div>
          <form [formGroup]="formDiferencial" novalidate>
            <div class="row">
              <div class="col" style="max-width: 250px">
                <div class="md-form">
                  <input value="" type="text" id="diferencialMonto" class="form-control" placeholder="$" required
                    #diferencialMonto formControlName="monto" monto />
                  <label for="diferencialMonto">Monto</label>
                  <div
                    *ngIf="formDiferencial.get('monto').invalid && (formDiferencial.get('monto').dirty || formDiferencial.get('monto').touched)">
                    <mdb-error *ngIf="formDiferencial.get('monto').hasError('required')"> Ingrese monto </mdb-error>
                    <mdb-error *ngIf="formDiferencial.get('monto').hasError('min')"> Monto no válido </mdb-error>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="diferencialMotivo" class="form-control" placeholder="EscribeMotivo" maxlength="500"
                    required #diferencialMotivo formControlName="motivo" />
                  <label for="diferencialMotivo">Motivo</label>
                  <div
                    *ngIf="formDiferencial.get('motivo').invalid && (formDiferencial.get('motivo').dirty || formDiferencial.get('motivo').touched)">
                    <mdb-error *ngIf="formDiferencial.get('motivo').hasError('required')"> Ingrese motivo </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <app-api-button (click2)="guardarPagos()" [processing]="processing"> Guardar </app-api-button>
      </div>
    </div>
  </div>
</div>